export default "__VITE_ASSET__Bbgz1NEd__"